import { Action } from 'redux';
import * as shallowEqual from 'shallowequal';

import { FeatureFlags } from '../../../ts/FeatureFlags';
import { ExplorableItemType } from '../../../ts/models/ContentType';
import { isFilterContentTypeAction } from '../../actions/spaces/ContentExplorerFilterActions';
import { isEnterSpaceAction } from '../../actions/spaces/EnterSpaceAction';
import {
  GroupSubspaceName, groupSubspaceNameToExplorableItemType,
  ScheduleSubspaceName,
  scheduleSubspaceNameToExplorableItemType,
  SearchSubspaceName,
  searchSubspaceNameToExplorableItemType,
  ServerTasksSubspaceName,
  serverTasksSubspaceNameToExplorableItemType,
  SiteTasksSubspaceName,
  siteTasksSubspaceNameToExplorableItemType,
  SiteUserSubspaceName,
  siteUserSubspaceNameToExplorableItemType,
  WorkbookSubspaceName,
  workbookSubspaceNameToExplorableItemType,
} from '../../state/SpaceInfo';

export function contentTypeFilterValuesReducer(
  previousState: ReadonlyArray<ExplorableItemType> | null = null,
  action: Action = null
): ReadonlyArray<ExplorableItemType> | null {
  if (isFilterContentTypeAction(action)) {
    if (!previousState || !shallowEqual(previousState.values, action.contentTypes)) {
      return action.contentTypes;
    }

  } else if (isEnterSpaceAction(action)) {
    let newState: ExplorableItemType[] = [];

    if (action.spaceType === 'project') {
      return previousState;

    } else if (action.spaceType === 'collection') {
      return previousState;

    } else if (action.spaceType === 'search') {
      const explorableItemType = searchSubspaceNameToExplorableItemType(action.subspaceName as SearchSubspaceName) as ExplorableItemType;
      newState = [explorableItemType];
    } else if (action.spaceType === 'sites') {
      newState = ['site'];

    } else if (action.spaceType === 'schedules') {
      newState = ['schedule'];

    } else if(action.spaceType === 'schedule') {
      const explorableItemType = scheduleSubspaceNameToExplorableItemType(action.subspaceName as ScheduleSubspaceName) as ExplorableItemType;
      newState = [explorableItemType];

    } else if (action.spaceType === 'workbook') {
      const explorableItemType = workbookSubspaceNameToExplorableItemType(action.subspaceName as WorkbookSubspaceName) as ExplorableItemType;
      newState = [explorableItemType];

    } else if (action.spaceType === 'serverusers') {
      newState = ['serveruser'];

    } else if (action.spaceType === 'siteusers') {
      newState = ['siteuser'];

    } else if (action.spaceType === 'siteuser') {
      if(action.subspaceName === 'content') {
        // if we're entering the content space, we've already set up the state for mixed content. no need to do it again.
        return previousState;
      } else {
        const explorableItemType = siteUserSubspaceNameToExplorableItemType(action.subspaceName as SiteUserSubspaceName) as ExplorableItemType;
        newState = [explorableItemType];
      }

    } else if (action.spaceType === 'datasource') {
      if (action.subspaceName === 'views') {
        newState = ['view'];
      } else if (action.subspaceName === 'datasources') {
        newState = ['datasource'];
      } else if (action.subspaceName === 'dataconnections' || action.subspaceName === 'connections'){
        newState = ['dataconnection'];
      } else if (action.subspaceName === 'connectedWorkbooks') {
        newState = ['workbook'];
      } else {
        newState = [];
      }
    } else if (action.spaceType === 'metric') {
      newState = ['metric'];
    } else if (action.spaceType === 'recents') {
      if (FeatureFlags.metricsSpaceEnabled) {
        newState = ['metric', 'view'];
      } else {
        newState = ['view'];
      }
    } else if (action.spaceType === 'recommendations') {
      newState = ['recommendedView'];
    } else if (action.spaceType === 'backgroundJobs') {
      newState = ['backgroundJob'];
    } else if (action.spaceType === 'dataRole') {
      if (action.subspaceName === 'connectedFlows'){
        newState = ['flow'];
      } else if (action.subspaceName === 'connectedDatasources'){
        newState = ['datasource'];
      } else {
        newState = [];
      }
    } else if (action.spaceType === 'collections') {
      newState = ['collection'];
    } else if (action.spaceType === 'sitetasks') {
      const explorableItemType = siteTasksSubspaceNameToExplorableItemType(action.subspaceName as SiteTasksSubspaceName) as ExplorableItemType;
      newState = [explorableItemType];
    } else if (action.spaceType === 'servertasks') {
      const explorableItemType = serverTasksSubspaceNameToExplorableItemType(action.subspaceName as ServerTasksSubspaceName) as ExplorableItemType;
      newState = [explorableItemType];
    } else if (action.spaceType === 'groups') {
      newState = ['group'];
    } else if (action.spaceType === 'group') {
      newState = ['siteuser'];
    }

    if (!previousState || !shallowEqual(newState, previousState.values)) {
      return newState;
    }
  }
  return previousState;
}
